import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWhomSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-68">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-3xl md:text-4xl font-extrabold text-white text-center mb-16" data-id="element-69">
        PARA QUIÉN ES ESTE PACK
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-slate-900/80 border border-emerald-500/30 rounded-2xl p-8 shadow-lg" data-id="element-71">
          <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-72">
            <div className="bg-emerald-500/20 p-2 rounded-full" data-id="element-73">
              <CheckIcon className="w-6 h-6 text-emerald-500" data-id="element-74" />
            </div>
            ES PARA VOS SI:
          </h3>
          <ul className="space-y-4 text-slate-300 text-lg" data-id="element-75">
            <li className="flex items-start gap-3" data-id="element-76">
              <span className="text-emerald-500 mt-1 flex-shrink-0" data-id="element-77">✦</span>
              Sos dueño de una PyME o emprendimiento en crecimiento y sentís que
              la empresa depende demasiado de vos
            </li>
            <li className="flex items-start gap-3" data-id="element-78">
              <span className="text-emerald-500 mt-1 flex-shrink-0" data-id="element-79">✦</span>
              Sos gerente o mando medio que necesita herramientas reales para
              gestionar mejor a su equipo
            </li>
            <li className="flex items-start gap-3" data-id="element-80">
              <span className="text-emerald-500 mt-1 flex-shrink-0" data-id="element-81">✦</span>
              Estás en proceso de escalar tu empresa y sabés que sin estructura
              el crecimiento se convierte en caos
            </li>
            <li className="flex items-start gap-3" data-id="element-82">
              <span className="text-emerald-500 mt-1 flex-shrink-0" data-id="element-83">✦</span>
              Querés profesionalizar tu organización pero no tenés presupuesto
              para contratar a una consultora
            </li>
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-slate-900/80 border border-red-500/30 rounded-2xl p-8 shadow-lg" data-id="element-84">
          <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-85">
            <div className="bg-red-500/20 p-2 rounded-full" data-id="element-86">
              <XIcon className="w-6 h-6 text-red-500" data-id="element-87" />
            </div>
            NO ES PARA VOS SI:
          </h3>
          <ul className="space-y-4 text-slate-300 text-lg" data-id="element-88">
            <li className="flex items-start gap-3" data-id="element-89">
              <span className="text-red-500 mt-1 flex-shrink-0" data-id="element-90">✦</span>
              Buscás una solución mágica que no requiera ningún esfuerzo de tu
              parte
            </li>
            <li className="flex items-start gap-3" data-id="element-91">
              <span className="text-red-500 mt-1 flex-shrink-0" data-id="element-92">✦</span>
              Tenés una empresa de más de 500 empleados con departamentos de
              management consolidados
            </li>
            <li className="flex items-start gap-3" data-id="element-93">
              <span className="text-red-500 mt-1 flex-shrink-0" data-id="element-94">✦</span>
              No estás dispuesto a implementar lo que vas a aprender
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}